/**
 * Maps toast types to Skylab status values
 * @param {string} toastType - The type of toast (e.g., 'success', 'error', 'warning', 'info')
 * @returns {string} - The corresponding Skylab status
 */
export const getToastStatus = function(toastType = "") {
  switch(toastType) {
    case "success":
      return "success";
    case "error":
      return "error";
    case "warning":
      return "warning";
    case "info":
      return "info";
    default:
      return "info";
  }
};

/**
 * Creates a toast entry object for the Redux store
 * @param {string} id - Unique identifier for the toast
 * @param {string} title - The toast title
 * @param {string} message - The toast message/details
 * @param {string} type - The toast type ('success', 'error', 'warning', 'info')
 * @param {string} scope - Optional scope for filtering toasts
 * @returns {object} - Toast entry object
 */
export const createToastEntry = function(id, title, message, type, scope) {
  return {
    id,
    title,
    message,
    type,
    scope,
    timestamp: Date.now(),
    clear: () => {
      // This will be populated by the toast manager
      return true;
    }
  };
};

